import { Upload } from "@aws-sdk/lib-storage";
import { v4 } from "uuid";
import { PutObjectCommandInput, S3Client } from "@aws-sdk/client-s3";
import Mixpanel from "./mixpanel";
import { FetchHttpHandler } from "@smithy/fetch-http-handler";
import * as Sentry from "@sentry/react";
const S3_BUCKET = process.env.REACT_APP_ASSET_S3_BUCKET;
const REGION = "us-west-2";

export const uploadToS3 = (
  userId: string,
  file: File,
  folder: string,
  contentType: string,
  awsAccessKeyId: string | undefined,
  awsSecretAccessKey: string | undefined,
  awsSessionToken: string | undefined,
  onProgress: (progress: number) => void,
  onSuccess: (key: string) => void,
  onFailure: (error: any) => void
): void => {
  try {
    if (userId) {
      Mixpanel.track("s3_upload_start");

      const s3Client = new S3Client({
        region: REGION,

        credentials: {
          accessKeyId: awsAccessKeyId!,
          secretAccessKey: awsSecretAccessKey!,
          sessionToken: awsSessionToken!,
        },
        requestHandler: new FetchHttpHandler({
          requestTimeout: 60000 // 60 seconds per request (same as socketTimeout)
        }),
        maxAttempts: 3, // retry 3 times
      });
      const key = `${folder}/${v4()}`;
      const target: PutObjectCommandInput = {
        Bucket: S3_BUCKET,
        Key: key,
        Body: file,
        ContentDisposition: `attachment; filename=${file.name}`,
        ContentType: contentType,
      };
      try {
        console.log("starting upload");
        const parallelUploads3 = new Upload({
          client: s3Client,
          params: target,
          queueSize: 4, // parallel parts within one file
        });

        parallelUploads3.on("httpUploadProgress", (progress) => {
          onProgress((progress.loaded! / progress.total!) * 100);
        });

        parallelUploads3
          .done()
          .then(() => {
            Mixpanel.track("s3_upload_success");
            onSuccess(key);
          })
          .catch((err) => {
            console.log(err);
            Sentry.captureException(err, {
              extra: {
                fileName: file.name,
                folder,
                userId,
                s3Key: key,
                contentType,
              },
            });
            Mixpanel.track("s3_upload_failure");
            onFailure(err);
          });
      } catch (err) {
        Sentry.captureException(err, {
          extra: {
            fileName: file.name,
            folder,
            userId,
            s3Key: key,
            contentType,
          },
        });
        console.log(err);
        Mixpanel.track("s3_upload_failure");
        onFailure(err);
      }
    }
  } catch (error: any) {
    Sentry.captureException(error, {
      extra: {
        userId,
        fileName: file.name,
        folder,
        contentType,
      },
    });
    console.log(error);
    onFailure(error);
  }
};

export const awaitableUploadToS3 = (
  userId: string,
  file: File,
  folder: string,
  contentType: string,
  awsAccessKeyId: string | undefined,
  awsSecretAccessKey: string | undefined,
  awsSessionToken: string | undefined,
  onProgress: (progress: number) => void
): Promise<string> => {
  return new Promise((resolve, reject) => {
    uploadToS3(
      userId,
      file,
      folder,
      contentType,
      awsAccessKeyId,
      awsSecretAccessKey,
      awsSessionToken,
      onProgress,
      (successResponse) => {
        resolve(successResponse);
      },
      (errorResponse) => {
        reject(errorResponse);
      }
    );
  });
};
